module.exports = __webpack_public_path__ + "static/media/card3.14110f26.png";